import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { commonActions } from "stores/common/commonActions";
import { FaqAction } from "stores/FaqTableStore/FaqAction";

const mapStateToProps = (state) => {
  return {
    CategoriesList:state.Faq.CategoriesList,
    ParentCategoriesList: state.Faq.ParentCategoriesList,

  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      // getCategoriesList: FaqAction.getFaqCategories,
      // getSelectCategoriesAction:FaqAction.getSelectCategories,
      getCategoriesList: FaqAction.getFaqCategories,
      getFaqParentCategories: FaqAction.getFaqParentCategories,
      PostFaqCategories: FaqAction.PostFaqCategories,
      FaqCategoriesDeleteAction: FaqAction.FaqCategoriesDeleteAction,
      snackbarAction:commonActions.setSnackbarAction
    },
    dispatch
  );

const FaqCategoryStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default FaqCategoryStore;
